import Component from '@bythepixel/component-loader';
import { Map } from 'mapbox-gl';
import LngLat from '../findDealer/largeMap/lngLat';
import LngLatBounds from '../findDealer/largeMap/lngLatBounds';
import MapMarker from '../findDealer/largeMap/mapMarker';

export default class DealerLocatorMap extends Component {
  static selector = '[data-comp-dealer-locator-map]';

  #map;
  #bounds;
  #markers = [];
  #visibleMarkers = {};

  constructor(...args) {
    super(...args);
    this.#bounds = new LngLatBounds(undefined, undefined);
    this.createMap();
  }

  createMap() {
    this.#map = new Map({
      accessToken:
        'pk.eyJ1IjoiY2ltYXJyb250cmFpbGVycyIsImEiOiJja21lYzJpZWowYTIxMnZvM20xdGdiOThhIn0.O6sNFGLk3Wo7ZiYFZkdN2w',
      container: this.$container,
      style: 'mapbox://styles/mapbox/outdoors-v11',
      fitBoundsOptions: {
        padding: {
          top: 80,
          left: 20,
          right: 20,
          bottom: 20,
        },
      },
    });
  }

  get() {
    return this.#map;
  }

  addMarker(data) {
    if (!this.#markers[data.id]) {
      const latLng = new LngLat(data.latitude, data.longitude);
      this.#bounds.add(latLng.get());
      this.#markers[data.id] = new MapMarker(data, this.#map);
    }
    this.#markers[data.id].getMarker().addTo(this.#map);
    this.#visibleMarkers[data.id] = this.#markers[data.id];
    return this.#markers[data.id];
  }

  removeMarker(data) {
    if (this.#markers[data.id]) {
      this.#markers[data.id].getMarker().remove();
      delete this.#visibleMarkers[data.id];
    }
  }

  fitBounds(bounds = this.#bounds.get()) {
    this.#map.resize();
    const isMobile = window.innerWidth < 768;
    const padding = isMobile ? 20 : 100;
    this.#map.fitBounds(bounds, { padding, maxZoom: 10 });
  }

  fitBoundsToVisible() {
    const bounds = new LngLatBounds(undefined, undefined);
    Object.values(this.#visibleMarkers).forEach((marker) => {
      bounds.add(marker.getLngLat());
    });
    this.fitBounds(bounds.get());
  }

  flyTo(options) {
    this.#map.flyTo(options);
  }
}
